export default {
  en: {
    supplier: {
      title: 'For suppliers',
      tooltip: 'Click to switch to supplier mode',
    },
    becomeSupplier: {
      tooltip: 'Click to become a supplier',
      title: 'Become a supplier',
      subTitle:
        '<b>Complete the last supplier due diligence assessment you should <br> ever have to do — with Risk Ledger.</b>',
      oldBody:
        'Becoming a supplier on the Risk Ledger platform will allow you to complete one security and  procurement assessment that you can securely and efficiently share with any client that requires you to take part in their third-party risk management programme. <p /> it is completely <b>free</b> to use the supplier side of the Risk Ledger platform so join suppliers like Stripe and CrowdStrike today.',
      body: 'Becoming a supplier on the Risk Ledger platform will allow you to complete one security and  procurement assessment that you can securely and efficiently share with any client that requires you to take part in their third-party risk management programme. <p /> it is completely <b>free</b> to use the supplier side of the Risk Ledger platform so join suppliers like Stripe and CrowdStrike today. Your connected clients will be able to see the names of your own suppliers in their network visualisation. You can disable this at any time in your settings.',
      button: 'Become supplier',
      requestDemo:
        'I am interested in scheduling a demo and learning more about the Risk Ledger platform as a supplier',
    },
    client: {
      title: 'For clients',
      tooltip: 'Click to switch to client mode',
    },
    becomeClient: {
      tooltip: 'Click to become a client',
      title: 'See your supply chain security the way your clients do',
      subTitle:
        "Since you're already using Risk Ledger as a supplier, why not try the client side? Use the same platform to assess your own suppliers:",
      features:
        '<li>Quickly connect to your suppliers - many already on the platform</li>\n        <li>Evaluate suppliers using the same assessment framework you are used to</li>\n        <li>Collaborate with your team on suppliers reviews</li>\n        <li>Visualise the health of your direct supply chain and fourth parties</li>',
      button: 'Try it out',
      requestDemo:
        'I am interested in scheduling a demo and learning more about the Risk Ledger platform as a client',
    },
    misc: {
      knowledgeBase: 'Knowledge base',
      knowledgeBaseTooltip: 'Learn more about suppliers',
      laterButton: 'Maybe later',
      requestDemo: 'Learn more',
      error: 'Failed to set organisation type, please try again.',
      noPermission:
        'Please contact your organisation Lead or Admin to request access for the {0} side of the Risk Ledger platform.',
    },
    tryItOut: {
      title: "You respond to security reviews. Now assess your suppliers' compliance.",
      cta: 'Try it out',
    },
    gettingStarted: {
      hero: {
        title: 'Respond to security questions faster with Risk Ledger',
        text: 'Complete once, share with your clients and never complete a questionnaire from scratch again.',
        link: 'Learn more about Risk Ledger',
      },
      securityProfile: {
        title: 'Complete your free security profile',
        invitedByOneText:
          'You’ve been requested by {inviter} to fill out a Risk Ledger security profile',
        invitedByManyText:
          'You’ve been requested by {number} clients to fill out a Risk Ledger security profile',
        invitedByNoneText:
          'Fill out your security information so you can share your security posture with your clients',
        startButton: 'Start',
        continueButton: 'Continue',
      },
      addUsers: {
        title: 'Need help? Add your colleagues',
        text: 'Add people within your organisation to help you fill out your profile',
        button: 'Add users',
      },
      otherFeatures: {
        title: 'Other available features',
        description:
          'Once you have completed your security profile you will unlock more features in Risk Ledger',
      },
      trustCentres: {
        title: 'Shareable Trust Centres',
        description: 'Share security posture information with your prospective clients.',
        cta: 'View',
      },
      externalMonitoring: {
        title: 'Monitor your public domains',
        description:
          'Get visibility into vulnerabilities in your public assets that your clients will see.',
        cta: 'View',
      },
    },
  },
};
